/**
 * Created by decipaliz on 20.06.2024
 */

const AdBlockWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            content: this.createContent(),
            name: "AdBlockWindow",
            title: Messages.get("AdBlockWindow.Title"),
            button: {
                text: Messages.get("AdBlockWindow.ButtonMessage")
            },
            styles: cleverapps.styles.AdBlockWindow.window
        });

        cleverapps.dataLoader.save(DataLoader.TYPES.AD_BLOCK_WINDOW_LAST_SHOWN, Date.now());
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.ADS.AD_BLOCK_WINDOW_DAU);
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "sad"
        };
    },

    createContent: function () {
        const styles = cleverapps.styles.AdBlockWindow;

        const icon = new cc.Sprite(bundles.adblock_window.frames.adblock_icon_png);

        const turnOffAdblockText = cleverapps.UI.generateOnlyText(Messages.get("AdBlockWindow.TurnOffAdblock"), cleverapps.styles.FONTS.WINDOW_TEXT);
        turnOffAdblockText.setDimensions(cleverapps.styles.AdBlockWindow.text.width, 0);
        turnOffAdblockText.fitTo(undefined, cleverapps.styles.AdBlockWindow.text.height);
        turnOffAdblockText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        turnOffAdblockText.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([icon, turnOffAdblockText], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    listBundles: function () {
        return ["adblock_window"];
    }
});

AdBlockWindow.CanBeShown = function () {
    if (cleverapps.config.type === "merge2" && Merge2.current && Merge2.current.mode === Merge2.MODE_GAME) {
        return false;
    }

    cleverapps.dataLoader.load(DataLoader.TYPES.PLACEMENTS);
    const lastShown = cleverapps.dataLoader.load(DataLoader.TYPES.AD_BLOCK_WINDOW_LAST_SHOWN);
    if (lastShown && lastShown + cleverapps.parseInterval("3 days") > Date.now()) {
        return false;
    }

    if (cleverapps.paymentsHistory.classify() !== cleverapps.PaymentsHistory.BRACKET_NONE) {
        return false;
    }

    return true;
};

cleverapps.styles.AdBlockWindow = {
    window: {
        padding: {
            top: 100,
            bottom: 100
        },

        margin: 50
    },

    margin: 40,
    text: {
        width: 600,
        height: 130
    }
};